import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=7f4c786a&scoped=true&"
import script from "./ProjectDetail.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=7f4c786a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4c786a",
  null
  
)

export default component.exports